import Button, { ButtonProps } from "@mui/material/Button/Button";
import i18nPackage from "../../i18n/i18n";
import { SvgIcon } from "@mui/material";
import CaretUp from "../images/caret-small.svg?react";

type BackButtonProps = {
	onBack: () => void;
	ariaLabel?: string;
	/**Text of the button @default "back" */
	variant?: "back" | "cancel";
	text?: string;
	padding?: string;
	/**When true, renders only the icon with no visible text. The accessible name still comes from `ariaLabel` (falling back to the button's text) @default false */
	iconOnly?: boolean;
} & Omit<ButtonProps, "onClick" | "aria-label" | "startIcon" | "children" | "variant">;

export default function CoreBackButton({
	onBack,
	ariaLabel,
	variant = "back",
	text,
	padding,
	iconOnly = false,
	...props
}: BackButtonProps) {
	const buttonText =
		text ??
		(variant === "back"
			? i18nPackage.t("coreComponents.backButton.back")
			: i18nPackage.t("coreComponents.backButton.cancel"));
	return (
		<Button
			variant="text"
			onClick={onBack}
			startIcon={
				<SvgIcon sx={{ transform: "rotate(-90deg)", fontSize: "15px", color: "#42296e" }} inheritViewBox>
					<CaretUp />
				</SvgIcon>
			}
			aria-label={ariaLabel ?? buttonText}
			disableFocusRipple
			{...props}
			sx={{
				textTransform: "none",
				color: "#333333",
				padding: padding ?? "0",
				fontSize: "0.875rem",
				marginLeft: !iconOnly ? "-0.25rem" : "0",
				minWidth: iconOnly ? "auto" : undefined,
				"& .MuiButton-startIcon": iconOnly ? { marginRight: 0 } : undefined,
				"&:focus-visible": {
					outline: "2px solid var(--focus-outline-color-dark)",
					outlineOffset: "2px",
					backgroundColor: "rgba(0, 0, 0, 0.04)",
				},
				...props.sx,
			}}
		>
			{!iconOnly && (buttonText)}
		</Button>
	);
}
